
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetDangerousSelectedIec as ObiAisTargetDangerousSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-dangerous-selected-iec.js';
 
 
 

 
 export const ObiAisTargetDangerousSelectedIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-dangerous-selected-iec',
   elementClass: ObiAisTargetDangerousSelectedIecElement,
   events: {
     
   }
  });
 
 